<template>
  <div style="margin-top: 30px; height: 100%; width: 100%; text-align: center" >
    <div v-for="(option, index) in tokenPurchaseoptions" v-bind:key="index">
      <div class="card mb-2 custom-card" @click="alertNow('option1')" tabindex="-1" data-toggle="modal" data-target="#confirmPurchase">
        <div class="card-body card-body-tries">
          <h3 class="card-title">{{ option.title }} [${{ option.cost }}]</h3>
          <small class="text-muted">{{ option.text }}</small>
        </div>
        <div class="card-footer text-muted card-footer-tries">
          <div class="py-1 px-1 code-box-border bg-success w-100 d-flex">
              <button class="btn btn-success w-100" @click="alertNow(option.id)">PURCHASE</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Button trigger modal -->
    <!-- <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#confirmPurchase">
      Launch demo modal
    </button> -->

    <!-- Modal -->
    <div class="modal fade" id="confirmPurchase" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalCenterTitle">Modal title</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            ...
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
  import axios from 'axios';
  import { NumbersModel } from '../models/numbers';

  export default {
        data() {
            return {
                triesSelection: '',
                hideModal: true,
                tokenPurchaseoptions: []
            }
        },
        methods: {
            getHistoryInfoByCode() {
                this.$http.get(this.appConfig.$api_url + '/api/numbers/' + 5604).then(
                        response => {
                          this.numbers = response.data.numbers;
                        }
                    ).catch(
                      error => console.log(error)
                    );
            },
            alertNow(triesOptionSelected) {
              //console.log('Selected: ' + triesOptionSelected)
              //alert('Selected: ' + triesOptionSelected)
              this.hideModal = false
              this.triesSelection = triesOptionSelected
            }
        },
        mounted: function () {
          //console.dir(this.numbers);
          //this.getHistoryInfoByCode();
          //console.log(this.$route.name)
          NumbersModel.getTokenOptions(this.$route.params.id).then(resp => {
            console.log(resp)
            this.tokenPurchaseoptions = resp.data.token_options
					})
					.catch(err => {
					  console.log(err)
					})
        }
    }
</script>
<style scoped>

hr {
	margin-top: 10px;
    margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/gettries.vue